import React, { Component, Fragment } from 'react';
import Decorator from '../../../../functions/decorator';

export default class RadioSelector extends Component {
    constructor(props) {
        super(props);
        this.select = this.select.bind(this);
    }

    isSelected() {
        if(this.props.modifierKey === this.props.selected) {
            return true;
        }
        return false;
    }

    select() {
        this.props.select(this.props.modifierKey);
    }

    render() {
        return (
            <div onClick={this.select} className="col radio-row">
                <label className="container row" onClick={this.props.showChangeSelectionBtn}><span className="pl-3">{this.props.name}</span>
                    <input type="checkbox" checked={this.isSelected() ? 'checked' : ''} />
                        <span className="checkmark"></span>
                </label>
            </div>
        );
    }
}


{/*<div className="clickable-element col-sm"  onClick={this.select}>*/}
{/*<p className={this.isSelected() ? 'selected-radio clickable-element' : 'clickable-element'}>{Decorator.capitalizeFirst(this.props.name)}</p>*/}
{/*<span className={`clickable-element ${this.isSelected() ? 'store-fg-accent' : 'store-fg-primary-very-translucent'} icon-full-circle medium-circle`}></span>*/}
{/*</div>*/}